// extracted by mini-css-extract-plugin
export default {"warpper":"Layout_warpper__L1+-N","header":"Layout_header__SYut0"};